import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import TruckKanbanService from '../../../../../services/TruckKanbanService';
import { onValueChange } from "../../../../../utils/handleChangeHooks";
import { translate, downloadFile, formatData, enumText, closeCollapsible, showMessageToast, isNullOrEmpty } from '../../../../../utils/util';
import { BackButton, Button, Title, ListPagination, Input, Select, Modal, Collapsible } from '../../../../../components/UI/ComponentsUI';
import * as actionsTruckKanban from '../../../../../actions/truckKanbanAction';
import SelectResourceMvi from '../SelectResourceMvi';
import { ENUMS } from '../../../../../utils/constants';

const MviList = (props) => {
    const getStatusMvi = (value) => translate(enumText(ENUMS.eMviStatus, value));
    const [openModal, setOpenModal] = useState({ open: false, mviId: undefined });
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [refresh, setRefresh] = useState(0);
    const [printer, setPrinter] = useState({});
    const [filterSearch, setFilterSearch] = useState({
        partNumberCode: '',
        mvmNumber: '',
        mvi: '',
        cim: '',
        journey: '',
        hasJourney: null
    })

    useEffect(() => {
        if (props.mvis?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(props.mvis.items);
            } else {
                setData((prevState) => ([...prevState, ...props.mvis.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [props?.mvis?.items]);

    useEffect(() => {
        onSearch();
        // eslint-disable-next-line
    }, [currentPage, refresh]);

    const onChange = (event) => {
        onValueChange(event, filterSearch, setFilterSearch);
    };

    const onSearch = () => {
        const filterObj = {};
        Object.assign(filterObj, filterSearch);
        filterObj.PageSize = 20;
        filterObj.PageIndex = currentPage;
        setFilterSearch(filterObj);

        props.getFilter(filterObj, () => {
            closeCollapsible('filterMvi')
        });
    }

    const onReportMvi = (id) => {
        setOpenModal({ open: false, mviId: undefined })
        props.getReport(id, (response) => {
            downloadFile(response, `mvi${id}.pdf`, "data:application/pdf", true)
        });
    }

    const getNumItems = () => {
        return props.mvis?.totalCount || 0;
    }

    const downloadReport = () => {
        props.getReportMviList(filterSearch, (data) => {
            downloadFile(data, `MviList${Date.now()}.csv`, "data:text/csv", true);
        });
    }

    const getMvmInternal = (item) => {
        if (!isNullOrEmpty(item?.mvmInternal) && item.mvmInternal.length === 8) {
            return (
                <span className="truncate sixth-text-color" style={{ marginLeft: '10px' }}>
                    {`MVM AE : ${item.mvmInternal}`}
                </span>
            )
        }
    }

    const renderItem = (item) => {
        if (item.labels) {
            let unique = [...new Set(item.labels.map((r) => {
                return r.receipt.mvmNumber
            }))];

            var mvms = unique.join(' ,');
            return (
                <>
                    <span
                        className="title sixth-text-color right"
                        style={{ position: 'absolute', marginTop: '0px', right: '10px', zIndex: '999' }}
                    ><i onClick={() => {
                        setOpenModal({ open: true, mviId: item.id })
                    }} className={`mdi mdi-36px mdi-printer`} />
                    </span>
                    <div className="row" style={{ display: 'block', marginBottom: '0px' }} >
                        <span className="title sixth-text-color" style={{ marginLeft: '10px' }} >
                            {`${translate('truck-kanban:mvi')} : ${item.id}`}
                        </span>
                        <span className="title sixth-text-color" style={{ marginLeft: '10px' }} >
                            {getStatusMvi(item.status)}
                        </span>
                        {getMvmInternal(item)}
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            {`${translate('truck-kanban:mvm')}(s): ${mvms}`}
                        </span>
                        {
                            !item.hasJourney &&
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                {`${translate('truck-kanban:withoutJourney')}`}
                            </span>
                        }
                        <div>
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                {`${translate("driver", 'truck-kanban')}: ${item.driver || ""}`}
                            </span>
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                {`${translate("vehicle-plate", 'truck-kanban')}: ${item.vehiclePlate || ""}`}
                            </span>
                        </div>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            {` ${formatData(item.createdOn)}`}
                        </span>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            {` ${item.createdByDescription}`}
                        </span>
                    </div>
                </>
            )
        }
    };

    return (
        <div>
            <BackButton {...props} />
            <Title icon="mdi mdi-clipboard-list-outline" label={translate('mvi-list', 'truck-kanban')} />
            {getNumItems() > 0 && <i className={`mdi mdi-package-down above-btn`} style={{ cursor: 'pointer' }} onClick={downloadReport} />}
            <div className="container-fluid" style={{ marginTop: '5px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterMvi"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <div id="formInput" className="form-group">
                                <div className="row">
                                    <div className="col s6 no-padding">
                                        <div className="input-field">
                                            <Input
                                                id="mvi"
                                                name="mvi"
                                                label={translate('truck-kanban:mvi')}
                                                type="text"
                                                defaultValue={filterSearch.mvi || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col s6 no-padding">
                                        <div className="input-field">
                                            <Input
                                                id="cim"
                                                name="cim"
                                                label="CIM"
                                                type="text"
                                                defaultValue={filterSearch.cim || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col s6 no-padding">
                                        <div className="input-field">
                                            <Input
                                                id="journey"
                                                name="journey"
                                                label={translate('truck-kanban:journey')}
                                                type="text"
                                                defaultValue={filterSearch.journey || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col s6 no-padding">
                                        <div className="input-field">
                                            <Input
                                                id="mvmNumber"
                                                name="mvmNumber"
                                                label={translate('truck-kanban:mvm')}
                                                type="text"
                                                defaultValue={filterSearch.mvmNumber || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col s6 no-padding">
                                        <div className="input-field">
                                            <Input
                                                id="partNumberCode"
                                                name="partNumberCode"
                                                label={translate('truck-kanban:partNumber')}
                                                type="text"
                                                defaultValue={filterSearch.partNumberCode || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col s6 no-padding">
                                        <div className="input-field">
                                            <Select
                                                id="hasJourney"
                                                name="hasJourney"
                                                placeHolder={translate("placeholder.choose-an-option", 'truck-kanban')}
                                                data={[{ id: true, text: translate('truck-kanban:withJourney') },
                                                { id: false, text: translate('truck-kanban:withoutJourney') }]}
                                                change={onChange}
                                                defaultValue={filterSearch?.hasJourney || ''}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    />
                    <div className="row">
                        <div className="col s12 left">
                            <Button
                                full="true"
                                className="col s6 btn-principal"
                                text={translate('truck-kanban:search')}
                                onClick={() => {
                                    setCurrentPage(0);
                                    setRefresh(refresh + 1);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="subtitle" style={{ float: 'right', margin: '10px' }}>
                {translate('truck-kanban:records')} : {getNumItems()}
            </div>
            <div className="container-fluid" style={{ marginTop: '5px' }}>
                <div id="listtransmissions">
                    <ListPagination
                        page={props.mvis?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={data.map((item, index) => {
                            return (
                                renderItem(item, index)
                            );
                        })}
                    />
                </div>
            </div>
            <Modal
                open={openModal.open}
                id="ModalPrintDownload"
                closeModal={() => setOpenModal({ open: false, mviId: undefined })}
                content={`Relatorio MVI ${openModal.mviId}`}
                children={<SelectResourceMvi onChangePrinter={(printer) => {
                    setPrinter(printer);
                }} />}
                dismissible={false}
                onConfirm={() => {
                    if (printer && !isNullOrEmpty(printer?.address)) {
                        props.sendReportPrinter(printer, openModal.mviId, () => {
                            setOpenModal({ open: false, mviId: undefined })

                        })
                    } else {
                        return showMessageToast({ html: translate('select-resource', 'validations'), classes: 'red' });
                    }
                }
                }
                onCancel={() => onReportMvi(openModal.mviId)}
                btnCancel="Baixar"
                btnConfirm="Enviar Impressora"
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        mvis: state.truckKanbanReducer.mviList,
        resourceMvi: state.truckKanbanReducer.resourceMvi,
        resources: state.logisticsResourceReducer.list
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFilter: (filter, callback) => {
            dispatch(TruckKanbanService.searchMvi(filter, callback));
        },
        getReport: (id, callback) => {
            dispatch(TruckKanbanService.getReportMvi(id, callback));
        },
        sendReportPrinter: (printer, id, callback) => {
            dispatch(TruckKanbanService.sendReportFileMvi(printer, id, callback));
        },
        getReportMviList: (filter, callback) => {
            dispatch(TruckKanbanService.getReportMviList(filter, callback));
        },
        setResourceMvi: (resourceMvi) => {
            dispatch(actionsTruckKanban.setResourceMvi(resourceMvi));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MviList));